$(".editHead, .shareHead").click(function () {
    var data_target = $(this).data('target');
    $('.mobile-favorite-tab .modal-inner').css("bottom", "0px");
    $('.mobile-favorite-tab .modal-inner').css("top", "0px");
    var container_id = '#' + data_target;
    $('.mobile-favorite-tab').addClass('active');
    $('body').addClass('pdp-tab-mobile-active');
    $('html').addClass('pdp-tab-mobile-active');
    $('body').append('<div class="modal-backdrop fade show"></div>');
    $(container_id).css("bottom", "0px");
});

$(".mobile-favorite-tab .heading .close button").click(function () {
    $(this).closest('.mobile-favorite-tab .modal-inner').css("bottom", "-200%");
    $(this).closest('.mobile-favorite-tab .modal-inner').css("top", "inherit");
    $('.modal-backdrop').remove();
    $('body').removeClass('pdp-tab-mobile-active');
    $('.mobile-favorite-tab').removeClass('active');
    $('html').removeClass('pdp-tab-mobile-active');
});

$(".switch-button").click(function () {
    $('.save-button').toggle('d-flex');
    $('.private-section').toggle('d-block');
});

// Copy Link

let copyLink = document.getElementById("copy-link");
if(copyLink){
    copyLink.addEventListener("click",  function(){
        copyLink.classList.toggle("copy-link-click")
    });
}